import {join} from 'hopedove-dom/url'

export default url => {
    if (url.startsWith('/')) {
        const {VITE_HTTP_BASE_URL: BASE} = import.meta.env

        if (/^https?:\/\//.test(BASE)) {
            return join(BASE, url)
        }
        else {
            return join(self.location.origin, BASE, url)
        }
    }
    else {
        return url
    }
}
